package com.schoolconnect.app.repository.support

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.response.TicketListItemResponse
import com.schoolconnect.app.datasource.network.response.serverTotalCountOrNull
import com.schoolconnect.app.datasource.network.response.withServerTotalCount
import com.schoolconnect.app.feature.common.PageRequest
import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.util.scLog
import com.schoolconnect.app.repository.common.RepositoryCache
import com.schoolconnect.app.repository.common.tenantCacheKey
import kotlinx.coroutines.CoroutineScope

object SupportQueueRepository {
    private const val TAG = "[DATA_RETRIEVE_SC] SupportQueueRepository"
    private val pageCache = RepositoryCache<List<TicketListItemResponse>>()

    suspend fun loadPage(
        query: String = "",
        schoolId: String = "",
        requesterRole: String = "",
        status: String = "",
        periodStart: String? = null,
        pageIndex: Int = 0,
        pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
        sortBy: String = "updated_at",
        order: String = "desc",
        forceRemote: Boolean = false,
        refreshScope: CoroutineScope
    ): Result<List<TicketListItemResponse>> {
        val request = PageRequest(pageIndex, pageSize)
        val normalizedQuery = query.trim().takeIf { it.isNotBlank() }
        val normalizedSchoolId = schoolId.trim().takeIf { it.isNotBlank() && it != "All Schools" }
        val normalizedRole = requesterRole.trim().takeIf { it.isNotBlank() && it != "All Roles" }
            ?.uppercase()?.replace(" ", "_")
        val normalizedStatus = status.trim().takeIf { it.isNotBlank() && it != "All Statuses" }
        scLog("$TAG loadPage start query=${normalizedQuery ?: "<blank>"} school=${normalizedSchoolId ?: "<any>"} role=${normalizedRole ?: "<any>"} status=${normalizedStatus ?: "<any>"} pageIndex=${request.safePageIndex} pageSize=${request.safePageSize} forceRemote=$forceRemote")
        val key = tenantCacheKey("support:$normalizedQuery:$normalizedSchoolId:$normalizedRole:$normalizedStatus:$periodStart:$sortBy:$order:${request.offset}:${request.safePageSize}")
        if (forceRemote) pageCache.clear()
        return pageCache.load(refreshScope, TAG, "loadPage", key) { KtorApiClient.getSupportQueue(
            query = normalizedQuery,
            schoolId = normalizedSchoolId,
            requesterRole = normalizedRole,
            status = normalizedStatus?.uppercase()?.replace(" ", "_"),
            periodStart = periodStart?.trim()?.takeIf { it.isNotBlank() },
            limit = request.safePageSize,
            offset = request.offset,
            sortBy = sortBy,
            order = order
        ).map { items ->
            val result = items.distinctBy { it.id }.withServerTotalCount(items.serverTotalCountOrNull())
            scLog("$TAG loadPage complete count=${result.size} total=${result.serverTotalCountOrNull() ?: "<unknown>"}")
            result
        }.onFailure { throwable -> scLog("$TAG loadPage failure pageIndex=${request.safePageIndex}", throwable) } }
    }
}
